//= ========================================================================
import React from 'react';
import { View } from 'react-native-web';
import FullPageSimulator from '../../FullPageSimulator';
import OperatorCard from '../../../AuxiliaryComponent/OperatorComponent/OperatorCard';

const SelectOperatorFP = ({
  globJSON,
  simPlatform,
  headlineText,
  topTitle,
  operatorsList,
  numberColumns,
  enableScreen,
  withIcon,
  slideshowRefs,
  contentAlignedCenter,
}) => (
  <FullPageSimulator
    globJSON={globJSON}
    simPlatform={simPlatform}
    headlineText={headlineText}
    TopTitle={topTitle}
    WithGrayBackground={!enableScreen}
    slideshowRefs={slideshowRefs}
  >
    <View style={{ flexDirection: 'row', flexWrap: 'wrap', paddingHorizontal: 15 }}>
      {operatorsList.map((operator) => (
        <OperatorCard
          globJSON={globJSON}
          text={operator}
          withIcon={withIcon}
          numberColumns={numberColumns}
          contentAlignedCenter={contentAlignedCenter}
        />
      ))}
    </View>
  </FullPageSimulator>
);

export default SelectOperatorFP;
